import styled from "styled-components"

// Timeline status colors (matching ChevronTimeline)
// Compact size adjustments for card listing pages
// Auto-rebuild enabled via QuorumDesign watch process
const colors = {
    pending: {
        bg: "#ffffff",
        border: "#dee2e6",
        text: "#767676",
    },
    completed: {
        bg: "#f5faff",  // plum blue 0
        border: "#e7f1ff",  // plum blue 2
        text: "#495057",  // plum gray 7
    },
    current: {
        bg: "#e7f1ff",  // plum blue 1
        border: "#74a7f7",  // plum blue 3
        text: "#0b3d91",  // plum blue 9
    },
    vetoed: {
        bg: "#ffe5e5",  // plum red 1
        border: "#ff9999",  // plum red 3
        text: "#8b0000",  // plum red 9
    },
    "final-success": {
        bg: "#e6f7e9",  // plum green 1
        border: "#80d98f",  // plum green 3
        text: "#0d5c1f",  // plum green 9
    },
}

export const Container = styled.div`
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    margin: 6px 0;
    flex-shrink: 0;
`

export const Steps = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 1px;
    justify-content: flex-end;
`

export const Step = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 4px 9px;
    border-radius: 4px;
    border: 1px solid;
    font-family: Roboto, sans-serif;
    font-size: 11px;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0%;
    white-space: nowrap;
    transition: all 0.2s ease;

    background: ${props => colors[props.status]?.bg || colors.pending.bg};
    border-color: ${props => colors[props.status]?.border || colors.pending.border};
    color: ${props => colors[props.status]?.text || colors.pending.text};
    font-weight: ${props => (props.status === "current" || props.status === "vetoed" || props.status === "final-success") ? 600 : 500};

    @media (max-width: 1300px) {
        font-size: 9px;
        padding: 3px 7px;
    }

    @media (max-width: 1130px) {
        font-size: 9px;
        padding: 2px 6px;
    }

    @media (max-width: 768px) {
        font-size: 8px;
        padding: 2px 5px;
    }
`

export const Label = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
`

export const Arrow = styled.div`
    color: #9ca3af;
    font-size: 12px;
    font-weight: bold;
    flex-shrink: 0;

    @media (max-width: 1300px) {
        font-size: 11px;
    }

    @media (max-width: 1130px) {
        font-size: 10px;
    }

    @media (max-width: 768px) {
        font-size: 9px;
    }
`

export const Icon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 11px;
    color: inherit;
`

